import React, { Component } from 'react';
import {
  Button,
  FormGroup, Label,
  Input,
  Row, Col,
  Card, CardBody,
} from 'reactstrap';
import TextareaAutosize from 'react-textarea-autosize';
import AddEditSubsidiariesService from '../../services/AddEditSubsidiariesService';
import Validation from '../../services/Validation';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
class NewFleetCommunicationDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditCommunicationDetail: true,
      controls: {
        is_prospective: {
          value: false,
          valid: true,
          touched: false,
          required: false,
          invalidLength: null,
          showErrorMsg: false
        },
        communication_address: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          invalidLength: null,
          showErrorMsg: false
        },
        communication_state: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        communication_city: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        communication_state_name: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        communication_city_name: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        communication_pin_code: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        same_as_business: {
          value: false,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        }
      },
      isValidForm: false,
      isLoading: false,
      stateData: [],
      cityData: [],
      fleetByIdData: {}
    }
  }

  componentDidMount() {
    this.getState();
  }

  changeFleetRegType = (e) => {
    const { NewFleetBusinessDetail } = this.props;
    let { controls } = this.state;

    if (NewFleetBusinessDetail.current &&
      NewFleetBusinessDetail.current.state.controls) {
      const { is_prospective } = NewFleetBusinessDetail.current.state.controls;
      if (is_prospective.value) {
        controls.is_prospective.value = is_prospective.value;
      } else {
        controls.is_prospective.value = false;
      }
    }
    this.setState({
      controls
    });
    this.handleValidation(false);
  }


  async getCity() {
    try {
      const { controls } = this.state;


      if (!controls.communication_state.value) {
        return
      }

      let state_id = controls.communication_state.value;
      const uuidV4Regex = /^[A-F\d]{8}-[A-F\d]{4}-4[A-F\d]{3}-[89AB][A-F\d]{3}-[A-F\d]{12}$/i;
      // compared to:     /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-4{1}[a-fA-F0-9]{3}-[89abAB]{1}[a-fA-F0-9]{3}-[a-fA-F0-9]{12}$/

      const isValidV4UUID = uuidV4Regex.test(controls.communication_state.value);
      if (!isValidV4UUID) {
        if (this.props.from && (this.props.from === 'profile' || this.props.from === 'registration')) {

          if (controls.communication_state.value && this.state.stateData.length > 0) {
            let state = this.state.stateData.filter(x => x.name.toLowerCase() === controls.communication_state.value.toLowerCase());
            if (state.length > 0) {
              state_id = state[0].state_id;
            } else {
              return
            }
          }
        }
      }


      this.setState((prevState) => {
        return {
          ...prevState,
          isLoading: true
        };
      });
      const { data } = await AddEditSubsidiariesService.getCity(state_id);
      let { cityData } = this.state;
      cityData = [];
      if (data) {
        if (data.data && data.data.length > 0) {
          cityData = data.data;
        }
        if (controls.communication_city.value && cityData && cityData.length > 0) {
          const isValidV4UUID_city = uuidV4Regex.test(controls.communication_city.value);
          if (!isValidV4UUID_city) {
            let communication_city_id = cityData.filter(x => x.name.toLowerCase() === controls.communication_city.value.toLowerCase());
            if (communication_city_id && communication_city_id.length > 0) {
              controls.communication_city.value = communication_city_id[0].city_id;
            } else {
              controls.communication_city.value = null;
            }
          }
          let communication_city = cityData.filter(x => x.city_id === controls.communication_city.value);
          if (communication_city && communication_city.length > 0) {
            controls.communication_city_name.value = communication_city[0].name;
          } else {
            controls.communication_city_name.value = '';
          }
        }
      }

      this.setState((prevState) => {
        return {
          ...prevState,
          cityData,
          controls,
          isLoading: false
        };
      }, () => {
        if (this.props.refresh_state) {
          this.props.refresh_state();
        }
      });
    } catch (error) {
      this.setState((prevState) => {
        return {
          ...prevState,
          isLoading: false
        };
      });
      console.log(error);
    }
  }

  async getState() {
    try {
      const { data } = await AddEditSubsidiariesService.getState();
      let { stateData } = this.state;
      let { controls } = this.state;
      if (data) {
        stateData = [];
        if (data.data && data.data.length > 0) {
          stateData = data.data;
        }
        this.setState((prevState) => {
          return { ...prevState, stateData, isLoading: false, controls };
        }, () => {
          this.getCity();
        });
      }
    } catch (error) {
      this.setState((prevState) => {
        return { ...prevState, isLoading: false };
      });
      console.log(error);
    }
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    let { controls, cityData } = this.state;
    if (controlName === 'communication_pin_code') {
      if (!isNaN(controlValue)) {
        controls[controlName].value = controlValue;
      }
    } else {
      controls[controlName].value = controlValue;
    }

    controls[controlName].touched = true;
    this.setState({ controls, cityData }, () => {
      if (controlName === 'communication_state') {
        this.getCity();
      }
    });
    this.handleValidation();

  }

  handleValidation = (isSubmit = false) => {
    let { controls, isValidForm } = this.state;
    let { communication_state, communication_city, communication_address, communication_pin_code,
      is_prospective
    } = controls;


    if (!is_prospective.value && (communication_state.touched === true || isSubmit)) {
      communication_state = Validation.notNullValidator(communication_state);
      communication_state.valid = !communication_state.nullValue;
      if (communication_state.valid === false) {
        communication_state.showErrorMsg = true;
      } else {
        communication_state.showErrorMsg = false;
      }
    }


    if (!is_prospective.value && (communication_city.touched === true || isSubmit)) {
      communication_city = Validation.notNullValidator(communication_city);
      communication_city.valid = !communication_city.nullValue;
      if (communication_city.valid === false) {
        communication_city.showErrorMsg = true;
      } else {
        communication_city.showErrorMsg = false;
      }
    }

    if (!is_prospective.value && (communication_address.touched === true || isSubmit)) {
      communication_address = Validation.notNullValidator(communication_address);
      communication_address.valid = !communication_address.nullValue;
      if (communication_address.valid === false) {
        communication_address.showErrorMsg = true;
      } else {
        communication_address.showErrorMsg = false;
      }
    }



    if (!is_prospective.value && (communication_pin_code.touched === true || isSubmit)) {
      communication_pin_code = Validation.notNullValidator(communication_pin_code);
      communication_pin_code = Validation.validateLength(communication_pin_code, 6);
      communication_pin_code.valid = !(communication_pin_code.invalidLength || communication_pin_code.nullValue);
      if (communication_pin_code.valid === false) {
        communication_pin_code.showErrorMsg = true;
      } else {
        communication_pin_code.showErrorMsg = false;
      }
    }


    if (is_prospective.value) {
      communication_address.showErrorMsg = false;
      communication_address.valid = true;
      communication_city.showErrorMsg = false;
      communication_city.valid = true;
      communication_state.showErrorMsg = false;
      communication_state.valid = true;
      communication_pin_code.showErrorMsg = false;
      communication_pin_code.valid = true;
    }


    if (
      communication_state.valid === true &&
      communication_city.valid === true &&
      communication_address.valid === true &&
      communication_pin_code.valid === true
    ) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }



    this.setState({ controls, isValidForm });
    return isValidForm;
  }

  setFleetDetail = (uDetail = {}) => {
    let { fleetByIdData, controls } = this.state;
    if (this.props.fleetByIdData && Object.keys(this.props.fleetByIdData).length > 0) {
      fleetByIdData = this.props.fleetByIdData
    }
    if (uDetail && Object.keys(uDetail).length > 0) {
      fleetByIdData = uDetail;
    }
    if (fleetByIdData && Object.keys(fleetByIdData).length > 0) {
      controls.communication_address.value = fleetByIdData.communication_address;
      controls.communication_state.value = fleetByIdData.communication_state;
      controls.communication_city.value = fleetByIdData.communication_city;
      controls.communication_pin_code.value = fleetByIdData.communication_pin_code;
      if (fleetByIdData.communication_state_name) {
        controls.communication_state_name.value = fleetByIdData.communication_state_name;
      } else {
        controls.communication_state_name.value = '';
      }
      if (fleetByIdData.communication_city_name) {
        controls.communication_city_name.value = fleetByIdData.communication_city_name;
      } else {
        controls.communication_city_name.value = '';
      }
      controls.communication_city.showErrorMsg = false;
      controls.communication_address.showErrorMsg = false;
      controls.communication_state.showErrorMsg = false;
      controls.communication_pin_code.showErrorMsg = false;
      this.setState({
        controls,
        fleetByIdData
      }, () => {
        if (this.props.refresh_state) {
          this.props.refresh_state();
        }
        this.getState();
      })
    }
  }

  setSameAsOwnerCheckBoxValue = (e) => {
    const { NewFleetBusinessDetail, refEditOtherBusinessDetail } = this.props;
    let { controls } = this.state;
    const controlName = e.target.name;
    controls[controlName].value = !controls[controlName].value;
    if (NewFleetBusinessDetail.current &&
      NewFleetBusinessDetail.current.state.controls
      && controls[controlName].value) {
      let { address, state, city, pin_code } = NewFleetBusinessDetail.current.state.controls;

      if (address.value || state.value || city.value || pin_code.value) {
        controls.communication_address.value = address.value;
        if (this.props.from && (this.props.from === 'profile' || this.props.from === 'registration')) {
          if (state.value && refEditOtherBusinessDetail.current.state.stateData.length > 0) {
            let state_data = refEditOtherBusinessDetail.current.state.stateData.filter(x => x.name.toLowerCase() === state.value.toLowerCase());
            if (state_data.length > 0) {
              controls.communication_state.value = state_data[0].state_id;
            } else {
              controls.communication_state.value = '';
            }
          } else {
            controls.communication_state.value = '';
          }
          if (city.value) {
            controls.communication_city.value = city.value;
          }
        } else {
          controls.communication_state.value = state.value;
          controls.communication_city.value = city.value;
        }
        controls.communication_pin_code.value = pin_code.value;
      } else {
        controls[controlName].value = false;
      }
    } else {
      controls.communication_address.value = '';
      controls.communication_state.value = '';
      controls.communication_city.value = '';
      controls.communication_pin_code.value = '';
    }
    this.setState({
      controls
    }, () => {
      this.getCity();
    });
    this.handleValidation(true);
  }

  save = () => {
    if (!this.handleValidation(true)) {
      return
    }
    this.props.onSave();
  }

  handleOnCancel = () => {
    this.setFleetDetail({});
    this.props.onCancel('isCommuncationEditActive', false);
  }




  setLoading = (isLoading) => {
    this.setState({
      isLoading: isLoading
    })
  }

  render() {
    let { controls, isEditCommunicationDetail } = this.state;
    return (
      <div className={!isEditCommunicationDetail ? 'hidden' : ''}>
        {/* COMUNUCATION DETAIL */}
        {this.state.isLoading && <CustomSpinner />}
        <Card>
          <CardBody>
            <Row>
              <Col>
                <b style={{ marginRight: '30px' }}>COMMUNICATION DETAILS</b>
                <label className="custom-checkboax1--container">
                  <input type="checkbox" name="same_as_business" checked={controls.same_as_business.value}
                    onChange={(e) => this.setSameAsOwnerCheckBoxValue(e)}
                  />
                  <span className="checkmark1" />
                </label>&nbsp;&nbsp;<span className="text-capitalize">Same as business detail</span>
              </Col>
            </Row>
            <hr style={{ marginLeft: '-18px', marginRight: '-18px' }} />
            <Row>
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="communication_address">Address{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <TextareaAutosize
                    name="communication_address"
                    autocomplete="nofill"
                    id="communication_address"
                    // disabled={controls.same_as_business.value}
                    value={controls.communication_address.value}
                    minRows={3}
                    maxRows={5}
                    style={{ fontSize: '14px' }}
                    className="form-control"
                    onChange={(e) => this.handleInputChange({ target: { name: 'communication_address', value: e.target.value } })}
                    placeholder='Enter Address'
                  />
                  {controls.communication_address.showErrorMsg && <div className="error">*Please enter address.</div>}
                </FormGroup>
              </Col>
              <Col xl="6" md="12" xs="12">
                <Row>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="state">State{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                      <select className="form-control" name="communication_state"
                        onChange={(e) => this.handleInputChange(e)} value={controls.communication_state.value}
                      // disabled={controls.same_as_business.value}
                      >
                        <option value="" selected="true" disabled>Select state</option>
                        {
                          this.state.stateData && this.state.stateData.map((state) => (
                            <option key={state.state_id} value={state.state_id}>{state.name}</option>
                          ))
                        }
                      </select>
                      {controls.communication_state.showErrorMsg && <div className="error">*Please select state.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="communication_city">City{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                      <select className="form-control" name="communication_city"
                        onChange={(e) => this.handleInputChange(e)} value={controls.communication_city.value}
                      // disabled={controls.same_as_business.value}
                      >
                        <option value="" selected="true" disabled>Select city</option>
                        {
                          this.state.cityData && this.state.cityData.map((city) => (
                            <option key={city.city_id} value={city.city_id}>{city.name}</option>
                          ))
                        }
                      </select>
                      {controls.communication_city.showErrorMsg && <div className="error">*Please select city.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="pin">Pincode{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                      <Input
                        autocomplete="nofill"
                        type="text"
                        value={controls.communication_pin_code.value}
                        // disabled={controls.same_as_business.value}
                        name="communication_pin_code"
                        maxLength="6"
                        onChange={(e) => this.handleInputChange(e)}
                        id="communication_pin_code"
                        placeholder="Enter Pincode" />
                      {controls.communication_pin_code.showErrorMsg && <div className="error">*Please enter pincode.</div>}
                    </FormGroup>
                  </Col>
                </Row>
              </Col>

            </Row>
            {this.props.from && this.props.from === 'profile' && <Row>
              <Col xl="12" xs="12" md="12" className="text-align-right" >
                <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" onClick={this.handleOnCancel}>Cancel</Button>
                <Button className="mb-1 mr-1 btn-pill action-button profile-save-button" color="warning" onClick={this.save}>Save</Button>
              </Col>
            </Row>}
          </CardBody>
        </Card>
      </div>
    );
  }

}
export default NewFleetCommunicationDetail;